export default "__VITE_ASSET__BdkJ0A0c__"